var map = {
	"./ill1-academia.svg": 452,
	"./ill1-business.svg": 453,
	"./ill1.svg": 454,
	"./moneyback.png": 101,
	"./moneyback@2x.png": 102,
	"./satisfaction@2x.png": 78,
	"./thumb.svg": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;